import './vertical-tabs.scss';
import { uniqueID } from '../../utilities/js/helper';

class VerticalTabs {
    constructor (element, options) {
        const defaults = {
            navAttr: '[data-vertical-tabs="nav"] ul',
            inputAttr: 'input[type="radio"]'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$verticalTabs = element;
        this.$verticalTabsNav = this.$verticalTabs.querySelector(this.settings.navAttr);
        this.$verticalTabsToggle = this.$verticalTabs.querySelectorAll(this.settings.inputAttr);
        this.manualOverride = null;
    }

    initialize () {
        if (this.$verticalTabs.getAttribute('id') === null) {
            this.$verticalTabs.setAttribute('id', `vertical-tabs-${uniqueID()}`);
        }

        this.buildNavigation(this.$verticalTabsToggle, this.$verticalTabs.getAttribute('id'));

        if (this.$verticalTabsToggle.length > 0) {
            this.$verticalTabsToggle[0].checked = true;
            this.setChecked(this.$verticalTabsToggle[0].id);
        }

        this.setEvents();
    }

    setChecked (id) {
        const $allLabels = this.$verticalTabs.querySelectorAll('label');

        $allLabels.forEach(label => {
            const labelId = label.getAttribute('for');
            label.classList.remove('is--active');
            labelId === id && label.classList.add('is--active');
        });
    }

    buildNavigation ($elements, id) {
        $elements.forEach((el, index) => {
            const $label = el.nextElementSibling;
            const $item = document.createElement('li');
            let $newLabel = '';
            el.setAttribute('id', `${id}_${index}`);
            el.setAttribute('name', id);
            $label.setAttribute('for', el.getAttribute('id'));

            $newLabel = $label.cloneNode(true);

            $item.append($newLabel);
            this.$verticalTabsNav.append($item);
        });
    }

    setEvents () {
        this.$verticalTabsToggle.forEach(tab => {
            tab.addEventListener('change', () => {
                if (!this.manualOverride) {
                    this.setChecked(tab.id);
                }
            });
            const $label = tab.nextElementSibling;

            $label.addEventListener('click', (e) => {
                if (window.innerWidth < 1024) {
                    if (tab.checked) {
                        e.preventDefault();
                        this.manualOverride = tab.id;
                        tab.checked = false;
                        $label.classList.remove('is--active');
                        this.manualOverride = null;
                    }
                }
            });
        });

        window.resizeHandler.customFunctions.push(() => {
            if (window.innerWidth >= 1024) {
                this.manualOverride = null;
            }
        });
    }
}

export { VerticalTabs };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$verticalTabs = $context.querySelectorAll('[data-vertical-tabs="root"]');
        for (let i = 0; i < $$verticalTabs.length; i++) {
            const $verticalTabs = new VerticalTabs($$verticalTabs[i]);
            $verticalTabs.initialize();
        }
    }
});
